<div
  cdkDropList
  [cdkDropListData]="indicatorIds"
  (cdkDropListDropped)="onDrop($event)"
  class="">
  @for (indicatorId of indicatorIds; track $index) {
    @if (
      (wegweiser && wegweiserStore.getWegweiserIndicatorById(indicatorId)) ||
        indicatorStore.getById(indicatorId);
      as indicator
    ) {
      @if (!indicator) {
        <div class="text-color-secondary font-italic">
          Der Indikator steht nicht mehr zur Verfügung ...
        </div>
      } @else {
        <div
          class="flex gap-2 align-items-center surface-border"
          [ngClass]="{ 'pb-3 mb-3 border-bottom-1': !$last }"
          [cdkDragData]="indicatorId"
          cdkDrag>
          <i class="fas fa-ruler-vertical"></i>
          @if (wegweiser) {
            {{ indicator.name }}
          }
          @if (!wegweiser) {
            {{ indicatorStore.getFullName(indicator) }}
          }

          <i class="ml-auto text-right text-color-secondary">
            @if (captions[$index]; as caption) {
              <i [class]="caption.icon"></i> {{ caption.label }}
            }
          </i>

          <button
            pButton
            (click)="onUnselect(indicatorId)"
            class="p-button-xs"
            [rounded]="true"
            icon="fas fa-trash"
            severity="danger"></button>
        </div>
      }
    }
  }
</div>
